export default __webpack_public_path__ + "static/media/smile-outline.b3f58fdb.svg";